import { WEB_SDK_SOURCE } from '../../constants';
export var FrameApplePayIncomingMessageType;
(function (FrameApplePayIncomingMessageType) {
    FrameApplePayIncomingMessageType["start"] = "start_apple_pay";
})(FrameApplePayIncomingMessageType || (FrameApplePayIncomingMessageType = {}));
export var FrameApplePayOutgoingMessageType;
(function (FrameApplePayOutgoingMessageType) {
    FrameApplePayOutgoingMessageType["success"] = "apple_pay_success";
    FrameApplePayOutgoingMessageType["failure"] = "apple_pay_failure";
    FrameApplePayOutgoingMessageType["cancel"] = "apple_pay_cancel";
})(FrameApplePayOutgoingMessageType || (FrameApplePayOutgoingMessageType = {}));
export function isFrameStartApplePayMessage(message) {
    return message.type === FrameApplePayIncomingMessageType.start;
}
export function createFrameApplePaySuccessMessage(payment, merchantId) {
    return {
        source: WEB_SDK_SOURCE,
        type: FrameApplePayOutgoingMessageType.success,
        data: {
            apple_token: JSON.stringify(payment.token.paymentData),
            apple_pay_merchant_id: merchantId
        }
    };
}
export function createFrameApplePayFailureMessage() {
    return {
        source: WEB_SDK_SOURCE,
        type: FrameApplePayOutgoingMessageType.failure
    };
}
export function createFrameApplePayCancelMessage() {
    return {
        source: WEB_SDK_SOURCE,
        type: FrameApplePayOutgoingMessageType.cancel
    };
}
